import type { MyAppsEntryCategory, MyAppsSearchResult } from './myAppsTypes';

export const MY_APPS_CATEGORY_FILTERS = [
  'All',
  'Pinned',
  'Utilities',
  'Productivity',
  'IT Tools',
  'Analytics',
  'Microsoft 365'
] as const;

export type MyAppsCatalogFilter = (typeof MY_APPS_CATEGORY_FILTERS)[number];

export function matchesCatalogFilter(
  entry: MyAppsSearchResult,
  filter: MyAppsCatalogFilter,
  pinnedIds: ReadonlySet<string>
): boolean {
  if (filter === 'All') return true;
  if (filter === 'Pinned') return pinnedIds.has(entry.id.toLowerCase());
  return entry.category === (filter as MyAppsEntryCategory);
}

export function canReorderPinnedCatalog(filter: MyAppsCatalogFilter, query: string): boolean {
  return !query.trim() && (filter === 'All' || filter === 'Pinned');
}

export function compareCatalogEntries(
  left: MyAppsSearchResult,
  right: MyAppsSearchResult,
  pinnedIds: ReadonlySet<string>,
  pinnedOrder: readonly string[] = []
): number {
  const leftPinned = pinnedIds.has(left.id.toLowerCase()) ? 0 : 1;
  const rightPinned = pinnedIds.has(right.id.toLowerCase()) ? 0 : 1;
  if (leftPinned !== rightPinned) return leftPinned - rightPinned;
  if (leftPinned === 0 && pinnedOrder.length > 0) {
    const leftIndex = pinOrderIndex(pinnedOrder, left.id);
    const rightIndex = pinOrderIndex(pinnedOrder, right.id);
    if (leftIndex !== rightIndex) return leftIndex - rightIndex;
  }
  return left.title.localeCompare(right.title);
}

function pinOrderIndex(pinnedOrder: readonly string[], id: string): number {
  const index = pinnedOrder.findIndex((item) => item.toLowerCase() === id.toLowerCase());
  return index < 0 ? Number.MAX_SAFE_INTEGER : index;
}
